import { render, staticRenderFns } from "./ModalBuilding.vue?vue&type=template&id=1f108b05&scoped=true&"
import script from "./ModalBuilding.vue?vue&type=script&lang=js&"
export * from "./ModalBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f108b05",
  null
  
)

export default component.exports